import { Component, OnInit } from '@angular/core';
import { Invoice } from '../../../dto/invoice';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder } from '../../../../../node_modules/@angular/forms';
import { Country } from '../../../dto/country';
import { InvoicesService } from '../../services/invoices.service';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import {Payment} from '../../../dto/payment';
import {toDateTimeString} from '../../../providers/app-date-adapter';

@Component({
  selector: 'app-invoice-edit',
  templateUrl: './invoice-edit.component.html',
  styleUrls: ['./invoice-edit.component.css']
})
export class InvoiceEditComponent implements OnInit {


  invoice: Invoice;
  payment: Payment;
  invoiceForm: FormGroup;

  invoiceId = null;

  paymentForm: FormGroup;
  payments: Payment[];
  isLoadingPayments = false;
  isInvoiceLoading = false;




  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private location: Location,
    private invoicesService: InvoicesService
  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null) {

    } else {

      this.invoiceId = parseInt(id);
      this.loadInvoice(parseInt(id));
      this.loadPayments(parseInt(id));
      this.initPaymentForm();
    }
  }

  loadInvoice(id){

    this.isInvoiceLoading = true;
    this.invoicesService.get(id).subscribe(result => {
      // this.initForm(result);
      this.invoice = result;
      this.isInvoiceLoading = false;
    });
  }



  initForm(invoice: Invoice) {
    this.invoiceForm = this.formBuilder.group(invoice);
  }



  returnBack() {
    this.location.back();
  }

  onSubmit() {
    this.invoiceForm.value.orders = null;
    this.invoiceForm.value.product = null;
    this.invoiceForm.value.invoiceLineItems = null;

    this.invoicesService.update(this.invoiceForm.value)
      .subscribe(res => this.returnBack());
  }

  loadPayments(id){
    this.isLoadingPayments = true;
    this.invoicesService.getPayments(id).subscribe(result => {
      this.payments = result;
      this.isLoadingPayments = false;
    });
  }

  initPaymentForm() {
    this.payment = new Payment();
    this.payment.date = null;
    this.payment.amount = null;
    this.payment.invoiceId = this.invoiceId;
    this.paymentForm = this.formBuilder.group(this.payment);
  }

  onPaymentSubmit() {

    this.invoicesService.addPayment(this.paymentForm.value)
      .subscribe(result => {
        this.loadInvoice(this.invoiceId);
        this.loadPayments(this.invoiceId);
        this.initPaymentForm();
      });
  }

  deletePayment(paymentId: number){
    this.isLoadingPayments = true;
    this.invoicesService.deletePayment(paymentId)
      .subscribe(result => {
        this.loadInvoice(this.invoiceId);
        this.loadPayments(this.invoiceId);
        this.initPaymentForm();
        this.isLoadingPayments = false;
      });
  }
}
